import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title: 'Get more with DeFi',
    description:
      'Explore earning opportunities for your {stakeToken} through DeFi',
  },
};
